import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import useUserMe from "../hooks/useUserMe";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const userState = useUserMe();
  return <UserContext.Provider value={userState}>{children}</UserContext.Provider>;
};

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within UserProvider");
  }
  return context;
};

export default UserContext;
